/**
 * Utilities for per-video-and-language subtitle storage.
 * Provides a safe migration/fallback to the legacy `subtitle` key.
 */

function _getVideoId(videoId) {
    try {
        if (videoId) return videoId;
        const vp = JSON.parse(window.localStorage.getItem('videoProps') || 'null');
        if (vp && vp.id) return vp.id;
    } catch (_) {}
    return null;
}

export function getStorageKey(videoId, lang) {
    const vid = _getVideoId(videoId);
    let lng = lang;
    try {
        if (!lng) lng = JSON.parse(window.localStorage.getItem('setSelectedLng') || '"English"');
    } catch (_) {
        lng = lng || 'English';
    }
    if (vid) return `subtitle_${vid}_${lng}`;
    return `subtitle_${lng}`;
}

export function readSubtitleFromStorage(lang, videoId, opts = {}) {
    try {
        const key = getStorageKey(videoId, lang);
        const data = window.localStorage.getItem(key);
        if (data) return JSON.parse(data);

        // Only fallback to the legacy 'subtitle' key for English or when explicitly allowed.
        const allowLegacy = !!opts.allowLegacyFallback || lang === 'English';
        if (allowLegacy) {
            const legacy = window.localStorage.getItem('subtitle');
            if (legacy) return JSON.parse(legacy);
        }
    } catch (e) {
        console.error('readSubtitleFromStorage error', e);
    }
    return null;
}

export function writeSubtitleToStorage(subs, lang, videoId, opts = {}) {
    try {
        const key = getStorageKey(videoId, lang);
        window.localStorage.setItem(key, JSON.stringify(subs));
        // For compatibility, keep legacy 'subtitle' key updated for English or when explicitly requested
        const alsoLegacy = opts.alsoWriteLegacy || lang === 'English';
        if (alsoLegacy) {
            try {
                window.localStorage.setItem('subtitle', JSON.stringify(subs));
            } catch (_) {}
        }
        return true;
    } catch (e) {
        console.error('writeSubtitleToStorage error', e);
        return false;
    }
}

export function migrateLegacyToNewKey(lang, videoId) {
    try {
        const legacy = window.localStorage.getItem('subtitle');
        if (!legacy) return false;
        const key = getStorageKey(videoId, lang);
        if (!window.localStorage.getItem(key)) {
            window.localStorage.setItem(key, legacy);
            return true;
        }
    } catch (e) {
        console.error('migrateLegacyToNewKey error', e);
    }
    return false;
}
